module.exports = __webpack_public_path__ + "img/antes_despues_267.1e00e8b6.png";